import React from 'react'
import './ContentBody.css'
import { ChildrenProps } from '../../modules/types'

/**
 * ContentBody is designed to be used underneath the ContentHeader
 * in the main component for a route.
 *
 * return
 *   <>
 *     <ContentHeader></ContentHeader>
 *     <ContentBody></Content>
 *   <>
 *
 * If the content should scroll, or requires a FilterPanel, nest the content as below:
 *
 *   <ContentBody>
 *     <FilterPanel></Filter Panel>
 *     <Content></Content>
 *   </ContentBody>
 *
 * @param props
 * @constructor
 */
function ContentBody(props: ChildrenProps) {
  return (
    <div id="content-body">
      {props.children}
    </div>
  )
}

export default ContentBody
